import React from 'react'
import { useServer } from '../context/ServerContext'
import { FaServer } from 'react-icons/fa'
import { IconType } from 'react-icons'

const ServerStatsComponent: React.FC = () => {
	const { serverStats } = useServer()

	if (!serverStats) {
		return (
			<div className='text-center text-red-500'>
				Failed to load server stats
			</div>
		)
	}
	return (
		<section className='bg-sky-50 p-6 animate-slide-up md:col-span-1'>
			<h2 className='text-2xl font-semibold text-sky-600 mb-4 flex items-center gap-2'>
				{(FaServer as IconType)({ className: 'mr-2' })} Server{' '}
				<span
					className={`font-bold ${
						serverStats.status === 'Online'
							? 'text-green-400 animate-pulse-slow'
							: 'text-red-400'
					}`}
				>
					{serverStats.status}
				</span>
			</h2>
			<div className='grid grid-cols-1 md:grid-cols-2 gap-4 text-center'>
				<p className='text-base'>
					Online Players: <br></br>
					<span className='text-green-400'>{serverStats.onlinePlayers}</span>
				</p>
				<p className='text-base'>
					Total Accounts: <br></br>
					<span className='text-red-400'>{serverStats.totalAccounts}</span>
				</p>
				<p className='text-base'>
					Total Characters: <br></br>
					<span className='text-red-400'>{serverStats.totalCharacters}</span>
				</p>
				<p className='text-base'>
					Total Guilds: <br></br>
					<span className='text-red-400'>{serverStats.totalGuilds}</span>
				</p>
				<p className='text-base'>
					Top Reset Count: <br></br>
					<span className='text-red-400'>{serverStats.topResetCount}</span>
				</p>
				<p className='text-base'>
					Top Level: <br></br>
					<span className='text-red-400'>{serverStats.topCLevel}</span>
				</p>
			</div>
		</section>
	)
}

export default ServerStatsComponent
